import { useMutation } from "react-query"
// import { ResponseType } from "../../../Types/ServicesType/servicesType"
import { deleteActivity } from "../../services"
import usePopup from "../../../hooks/usePopup"

const useDeleteActivity = (onSuccess?:(result:any)=>void)=>{
    const {showSnackbar} = usePopup()
    return useMutation(deleteActivity,{
      onSuccess:(result)=>{
        if(result.responseIndicator == "success"){
            showSnackbar({
                message: result?.responseMessage || "",
                open: true,
                variant: "success",
                duration: 2000,
              });
              if(onSuccess){
                onSuccess(result)
              }
        }else{
            showSnackbar({
                message: result?.responseMessage || "",
                open: true,
                variant: "warning",
                duration: 2000,
              });
        }
      },
      onError:(e:any)=>{
        showSnackbar({
            message: e?.response?.data?.responseMessage || "Error !",
            open: true,
            variant: "error",
            duration: 2000,
          });
      }
    })
}

export default useDeleteActivity